import { isCenterInUnitedStates } from './isCenterInLocation'
import { isPremium, getLocationLabel, getAddress } from '../../center'
import { isNonEmptyString } from '../../../utils/checks'
import { Center } from '@/types/models'

const getCenterAddressForCard = (center: Center): string => {
  if (isPremium(center)) {
    return getLocationLabel(center)
  }

  const centerAddress = getAddress(center)

  if (isNonEmptyString(centerAddress) && isCenterInUnitedStates(center)) {
    return centerAddress
  }
  return getLocationLabel(center)
}

export default getCenterAddressForCard
